import React from "react";
import { useSelector } from "react-redux";
import "./styles.scss";
import ProductCard from "../ProductCard/ProductCard";
import { Link } from "react-router-dom";

const ProductsLimited = (props) => {
  const category = props.category;
  const mainCategory = props.mainCategory;

  // Live category labels from the Firestore-backed taxonomy.
  const SUB_CATEGORIES_TRANSLATION = useSelector((state) => state.categories.subTranslation);
  const CATEGORIES_TRANSLATION = useSelector((state) => state.categories.catTranslation);

  let categoryHeader = '';
  if (category.id) {
    categoryHeader = SUB_CATEGORIES_TRANSLATION[category.id] || category.id;
  } else if(mainCategory) {
    categoryHeader = CATEGORIES_TRANSLATION[mainCategory] || mainCategory;
  }
  let productList = [];
  for (let i = 0; i < props.category.products.length; i++) {
    const product = category.products[i];
    if (product) {
      productList.push(
        <ProductCard
          key={i}
          item={product}
          mainCategory={mainCategory}
          categoryId={category.id}
        />
      );
    }
  };
  return (
    <div className="limited_category_container">
      <h2 className="categoryHeader">{categoryHeader}</h2>
      <ul className="productList">{productList}</ul>
      <Link
        to={ mainCategory && category.id ? `/${mainCategory}/${category.id}` : `/${mainCategory}`}
        className="load_more btn btn-outline-primary">
        Загрузить больше
      </Link>
    </div>
  );
};
export default ProductsLimited;
